"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const differenceInYears_1 = require("date-fns/differenceInYears");
class Validation {
}
_a = Validation;
Validation.email = {
    regex: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    maxLength: 100,
    isValid(value) {
        return this.regex.test(value);
    },
};
Validation.firstName = {
    regex: /^[^±!@£$%^&*_+§¡€#¢§¶•ªº«\\/<>\\{\\}?:;|=.,1-9]+$/,
    maxLength: 32,
    isValid(value) {
        return this.regex.test(value);
    },
};
Validation.lastName = {
    regex: /^[^±!@£$%^&*_+§¡€#¢§¶•ªº«\\/<>\\{\\}?:;|=.,1-9]+$/,
    maxLength: 32,
    isValid(value) {
        return this.regex.test(value);
    },
};
Validation.zip = {
    regex: {
        CA: /^[a-zA-Z0-9]{6,6}$/,
        US: /^[0-9]{5,5}$/,
    },
    maxLength: {
        CA: 6,
        US: 5,
    },
    isValid: (value, country) => {
        if (['CA', 'US'].includes(country)) {
            return _a.zip.regex[country].test(value);
        }
        return true;
    },
};
Validation.mlifeNumber = {
    regex: /\d{10}$/,
    isValid(value) {
        if (value.length === 0) {
            return false;
        }
        return this.regex.test(value);
    },
};
Validation.address = {
    maxLength: 32,
};
Validation.activationCode = {
    regex: /^\d{6}$/,
    maxLength: 6,
    isValid(value) {
        return this.regex.test(value);
    },
};
Validation.password = {
    minLength: 12,
    maxLength: 20,
    validate: (password, userData) => {
        const validations = {
            length: password.length >= _a.password.minLength,
            uppercase: !!password.match(/(?=.*[A-Z])/),
            lowercase: !!password.match(/(?=.*[a-z])/),
            number: !!password.match(/(?=.*[0-9])/),
            // eslint-disable-next-line no-useless-escape
            specialCharacter: !!password.match(/(?=.*["!#$%&'()*+,-./\\:;<=>?@^_`{|}~\[\]])/),
            firstName: !userData.firstName || password.toLowerCase().indexOf(userData.firstName.toLowerCase()) === -1,
            lastName: !userData.lastName || password.toLowerCase().indexOf(userData.lastName.toLowerCase()) === -1,
        };
        return [Object.values(validations).every(validation => validation), validations];
    },
    isValid: (password, userData) => {
        const [isValid] = _a.password.validate(password, userData);
        return isValid;
    },
};
Validation.age = {
    min: 21,
    isValid: (value) => {
        try {
            const age = (0, differenceInYears_1.default)(new Date(), new Date(value));
            return age >= _a.age.min && !isNaN(age);
        }
        catch (e) {
            // Birthday is not a valid date
            return false;
        }
    },
};
exports.default = Validation;
